import type { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import type { MouseEvent } from "react";

export enum ButtonType {
  Primary = 0,
  Secondary = 1,
  Danger = 2,
}

export interface IButton {
  // Basic properties
  text: string | number;
  id?: string;
  disabled?: boolean;
  isSubmitButton?: boolean;

  // Icon properties
  icon?: IconDefinition;
  rightIcon?: IconDefinition;
  iconClasses?: string;
  rightIconClasses?: string;

  // Event handlers
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => void;

  // Styling properties
  /**
   * The type of button to display.
   * Optional.
   * Possible values: Primary, Secondary, Danger
   * @default ButtonType.Primary
   */
  buttonType?: string | ButtonType;
  padding?: string;
  fontSize?: string;
  fontWeight?: string;
  rounding?: string;
  margin?: string;
  width?: string;
  border?: string;
  outline?: string;
  extraClasses?: string;
  textClasses?: string;
}
